//
//
//
//
//
//
//
//

import $manager from "@/Manager/09.Cm/EnterpriseCodePlanOrder2.js";
import PageTabIndex from "@/0/components/0.comPage/01.comPageTabIndex";
export default {
  components: { 
    "page-tab-index": PageTabIndex 
  },
  data() {
    return {
      
      dataConfig: {

      },      

    };
  },

  methods: {
    getManager() {
      return $manager;
    },

    getDetailUrl() {
      return "/mGmsH5Api/EnterpriseCodePlanOrder2/Detail";
    },

  }
};
